import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const DotIcon = ({
  width = 4,
  height = 5,
  color = '#2CCCFF',
  viewBox = '0 0 4 5',
  ...props
}: IconProps) => (
  <SvgComponent viewBox={viewBox} width={width} height={height} {...props}>
    <circle cx={2} cy={2.5} r={2} fill={color} />
  </SvgComponent>
);
export default DotIcon;
